import React from 'react';
import { Alert, AlertDescription, AlertIcon, AlertTitle, Flex } from '@chakra-ui/react';
import { LoadingIndicator } from 'ts/common/components';
import Questionnaire from 'ts/common/components/questionnaire/Questionnaire';
import { useTranslate } from 'ts/common/hooks';
import { useClientBookingExperience } from 'client_react/booking/ClientBookingExperience';
import BookingSessionHeading from 'client_react/booking/components/BookingSessionHeading';
import useBookingFlowSteps from 'client_react/booking/hooks/useBookingFlowSteps';

const BookingQuestionnairePage: React.FC = () => {
    const t = useTranslate('booking.questionnairePage');

    const {
        bookingSession,
        bookingSessionType,
        error,
        questionnaire,
        requestFailed,
        saveQuestionResponse,
        saving
    } = useClientBookingExperience();

    const { goToPreviousStep, goToNextStep } = useBookingFlowSteps();

    return (
        <>
            {bookingSessionType && (
                <BookingSessionHeading
                    bookingSession={bookingSession}
                    bookingSessionType={bookingSessionType}
                />
            )}
            {questionnaire && 'pages' in questionnaire ? (
                <Questionnaire
                    error={error}
                    onGoBack={goToPreviousStep}
                    onSave={saveQuestionResponse}
                    onSubmit={goToNextStep}
                    questionnaire={questionnaire}
                    requestFailed={requestFailed}
                    saving={saving}
                />
            ) : requestFailed ? (
                <Alert status="error" flexDirection="column">
                    <Flex>
                        <AlertIcon />
                        <AlertTitle>
                            {error?.detail ?? t('errorLoadingQuestionnaireTitle')}
                        </AlertTitle>
                    </Flex>
                    <AlertDescription>{t('errorLoadingQuestionnaire')}</AlertDescription>
                </Alert>
            ) : (
                <LoadingIndicator />
            )}
        </>
    );
};

export default BookingQuestionnairePage;
